import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, url, image, type }) {
    const { site } = useStaticQuery(
        graphql`
      query {
        site {
          siteMetadata {
            url
            title
            author
          }
        }
      }
    `
    )

    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={site.siteMetadata.title}
            titleTemplate={title && `%s | ${title}`}
            defer={false}
            meta={[
                {
                    name: `description`,
                    content: description,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: description,
                },
                {
                    property: `og:type`,
                    content: type,
                },
                {
                    property: `og:url`,
                    content: `${site.siteMetadata.url}${url}`,
                },
                {
                    property: `og:image`,
                    content: image,
                },
                {
                    name: `twitter:card`,
                    content: `photo`,
                },
                {
                    name: `twitter:image`,
                    content: image,
                },
                {
                    name: `twitter:image:width`,
                    content: `560`,
                },
                {
                    name: `twitter:image:height`,
                    content: `750`,
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata.author,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: description,
                },
            ].concat(meta)}
        />
    )
}

SEO.defaultProps = {
    lang: `en`,
    meta: [],
    title: `Rishi Vedpathak`,
    description: `A Passionate Front-end Developer`,
    url: ``,
    image: `https://rishi-vedpathak.netlify.com/Rishi-Vedpathak.png`,
    type: `website`,
}

SEO.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.string,
    type: PropTypes.string
}

export default SEO